import React, { useContext, useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthContext from '../../authcontext/AuthContext';
import { NumericFormat } from "react-number-format";
import bedIcon from "../../../assets/bedIcon.png"
import bathIcon from "../../../assets/bathIcon.png"
import Bidding from './Bidding';
import axios from 'axios';
import { config } from '../../../utils/config';

export default function Dashboard() {

    const authData = useContext(AuthContext);
    const navigate = useNavigate()
    const [dashBoardItems, setdashBoardItems] = useState([])

    const edit = useCallback((lid) => {
        navigate(`/property/${lid}`)
    }, [navigate])


    const deleteListing = useCallback(async (lid) => {
        const result = await axios.delete(`${config.apiBaseUrl}/editlisting/${lid}`)
        console.log(result.data)
            navigate('/agent/dashboard')
    }, [navigate])

    useEffect(() => {

        const getDashBoardItems = async () => {

            const response = await axios.get(`${config.apiBaseUrl}/manage/`, { withCredentials: true })
            // console.log(response.data)
            setdashBoardItems(response.data)
        }

        getDashBoardItems()

    }, [])

    return (
        <>
            <div className="container-fluid p-1" style={{ width: "90%" }}>
                <h1>Agent Dashboard</h1>
                <h4>Hi, Welcome back ({authData.getUserDetail().ceaNo})!</h4>

                <div className="row row-cols-1 g-4">
                    {dashBoardItems.map((obj) => {
                        return (
                            <div className="col" key={obj.id}>
                                <div className="card mb-3" style={{ maxWidth: "1000px" }}>
                                    <div className="row g-0">
                                        <div className="col-md-4" style={{
                                            overflow: 'hidden',
                                            height: '200px',
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center'
                                        }}>
                                            <img src={obj.listingDetails.media[0].media_url} style={{ objectFit: 'cover', width: '100%', height: '100%' }} className="img-fluid rounded-start" alt="..." />
                                        </div>
                                        <div className="col-md-8">
                                            <div className="card-body">
                                                <h5 className="card-title">{obj.listingDetails.propertyDetails.project_name && obj.listingDetails.propertyDetails.project_name
                                                    !== "Nil" ? obj.listingDetails.propertyDetails.project_name : obj.listingDetails.propertyDetails.street_name}</h5>
                                                <p className="card-text" style={{ margin: "0", lineHeight: "1.5" }}>{obj.listingDetails.unit ? "#" + obj.listingDetails.unit : null}</p>
                                                <p className="card-text" style={{ margin: "0", lineHeight: "1.5" }}>{obj.listingDetails.propertyDetails.block} {obj.listingDetails.propertyDetails.street_name} {obj.listingDetails.propertyDetails.postal_code}</p>
                                                <p className="card-text" style={{ fontSize: "14px", margin: "0", lineHeight: "1.5" }}>
                                                    <NumericFormat className="card-text" prefix={"$"} suffix={""} thousandSeparator={true} value={obj.listingDetails.price} displayType={"text"} />
                                                    {" . "}<NumericFormat className="card-text" prefix={"$"} suffix={"psf (floor)"} thousandSeparator={true} value={Math.round(obj.listingDetails.price / obj.listingDetails.size_built)} displayType={"text"} />
                                                    {obj.listingDetails.size_land ? <NumericFormat className="card-text" prefix={" . $"} suffix={"psf (land)"} thousandSeparator={true} value={Math.round(obj.listingDetails.price / obj.listingDetails.size_land)} displayType={"text"} /> : null}
                                                </p>
                                                <p className="card-text" style={{ fontSize: "14px", margin: "0", lineHeight: "1.5" }}>
                                                    {obj.listingDetails.room}{" "}<img src={bedIcon} style={{ width: "20px" }} />
                                                    {" " + obj.listingDetails.bath + " "}<img src={bathIcon} style={{ width: "20px" }} />
                                                    {" . "}<NumericFormat className="card-text" prefix={""} suffix={"sqft (floor)"} thousandSeparator={true} value={obj.listingDetails.size_built} displayType={"text"} />
                                                    {obj.listingDetails.size_land ? <NumericFormat className="card-text" prefix={" . "} suffix={"sqft (land)"} thousandSeparator={true} value={obj.listingDetails.size_land} displayType={"text"} /> : null}
                                                </p>
                                                <div className='my-2'>
                                                    <Bidding key={obj.id} listingId={obj.listingDetails.id} /> <button className='btn btn-danger btn-sm mx-2' onClick={() => edit(obj.id)}>Edit</button><button className='btn btn-danger btn-sm' onClick={() => deleteListing(obj.id)}>Delete</button>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        </>
    )
}